const templateUrl = require('./pause.html');

const onEnter = ($state, $uibModal, subscriptionOrchestrator, $stateParams, $document) => {
  const modal = $uibModal.open({
    templateUrl: templateUrl,
    controller: require('./pause.controller'),
    controllerAs: '$ctrl',
    resolve: {
      nextOrderDate: () => subscriptionOrchestrator.getNthNextOrderDate($stateParams.subscription),
      subscription: () => $stateParams.subscription
    },
    backdrop: true,
    size: 'md',
    windowTopClass: 'og-pause-sub-modal',
    ariaLabelledBy: 'og-pause-subscription-modal-title',
    ariaDescribedBy: 'og-pause-subscription-modal-description'
  });

  modal.rendered.then(() => $document[0].querySelector('.og-modal-window').setAttribute('aria-modal', true));

  modal.result.catch(() => $state.go('root'));

  return modal;
};

onEnter.$inject = ['$state', '$uibModal', 'subscriptionOrchestrator', '$stateParams', '$document'];

module.exports = function($stateProvider) {
  $stateProvider.state('pause', {
    parent: 'root',
    params: {
      subscription: {}
    },
    onEnter: onEnter
  });
};

module.exports.$inject = ['$stateProvider'];
